
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Header } from './Header';
import { Hero } from './Hero';
import { Integrations } from './Integrations';
import { Features } from './Features';
import { Solutions } from './Solutions';
import { Pricing } from './Pricing';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { CTA } from './CTA';
import { Footer } from './Footer';

interface LandingPageProps {
    onLogin: () => void;
    onWatchDemo: () => void;
    onNavigateToDocs: (section?: string) => void;
    onNavigate?: (page: 'landing' | 'docs' | 'solutions' | 'card-landing' | 'about-landing' | 'legal') => void;
}

export const LandingPage: React.FC<LandingPageProps> = ({ onLogin, onWatchDemo, onNavigateToDocs, onNavigate }) => {
    return (
        <div className="bg-white dark:bg-[#0A0B0F]">
            <Header onLogin={onLogin} onNavigateToDocs={onNavigateToDocs} onNavigate={onNavigate} />
            <main>
                <Hero onGetStarted={onLogin} onWatchDemo={onWatchDemo} />
                <Integrations />
                <Features />
                <Solutions />
                <Testimonials />
                <Pricing onGetStarted={onLogin} />
                <FAQ />
                <CTA onGetStarted={onLogin} />
            </main>
            <Footer onLogin={onLogin} onNavigateToDocs={onNavigateToDocs} onNavigate={onNavigate} />
        </div>
    );
};
